export const CookieService = Symbol('CookieService');

export interface CookieService {
    match(pattern: RegExp): RegExpMatchArray | null;
}
